import template from 'header/utility-account.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import addDropdownSupport from '../../../core/js/uiSupport/dropDown';
import { mDom } from '../../../core/js/utils/renderUtils';
import { correctCookies } from '../../../core/js/utils/cookieUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-site-header .dom-utility-account',
        watch: ['core.initialized', 'core.loggedIn', 'core.profile', 'core.deviceCharacteristics'],
        name: 'accountComponent',
        renderType: mDom,
        firstRender: firstRender,
        onStateChange: onStateChange,
        template: template,
        addDropdownSupport: addDropdownSupport,
        correctCookies: correctCookies
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}

export function onStateChange(store, watchValue, oldValue, newValue) {
    const shouldHide = !!window.hideHeaderSignIn;

    const dictionary = {
        shouldHideHeaderLogin: shouldHide
    };

    this.render(store, this, dictionary);
    if(watchValue === 'core.loggedIn' || watchValue === 'core.deviceCharacteristics') {
        this.addDropdownSupport(this, this.templateLocation);
    } else if (watchValue === 'core.initialized' && newValue === true) {
        const state = store.getState();
        this.correctCookies(state);
    }
}

export function firstRender(store) {
    this.addDropdownSupport(this, this.templateLocation);
}
